/**
 * * @module pages/event-single.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _, { forEach } from "underscore";
import Bootstrap from "bootstrap";
import dotimeout from "../dotimeout";
import Filter from "../components/filter";
import InPageLinks from "../components/inpage-links";
import SwiperInstances from "../components/swiper-instances";

const Event = Backbone.View.extend({
  el: $(document),

  filter: undefined,

  events: {
    "click #article-title-button": "toggleInstances",
    "click h1 .icon": "toggleInstances",
    "change .event-instances__filter input[type='checkbox']": "setFilter",
    "click .event-instances__filter-reset": "resetFilter",
    // "click .event-status__title": "toggleStatus",
  },

  initialize: function () {

    this.render();

    $(document).on('click', (e) => {
      const $open = $(".filter-dropdown__drop.show");

      if(!$open.length) return;

      if(!$open.is(e.target) && $open.has(e.target).length === 0) {
        $open.collapse('hide');
      }
    })
  },

  moveMoreInfoBtn: function(){
    if( $(window).width() < 1024) {
      const $btn = $('.instance-book-button.button.secondary');
      if($btn){
        $btn.closest(".item").append($btn)
      }
      
    }
  },

  getUrlParameter: function (sParam = "") {
    const isBook = window.location.hash;

    if (isBook == "book") {
      $("#article-title-button").trigger("click");
    }
  },

  // toggleStatus: function(e) {
  //   const details = e.target.closest(".event-status__details");
  //   const content = details.querySelector(".event-status__row");

  //   setTimeout(() => {
  //     if(!details.open) {
  //       content.style.maxHeight = content.scrollHeight + 'px';
  //     } else {
  //       content.style.maxHeight = '0px';
  //     }
  //   }, 0)
  // },

  toggleInstances: function (e) {
    var _this = this;
    const $bookButton = $("#article-title-button");
    const $articleContent = $(".article-sidebar, .article-body, .inpage-links");
    const $eventInstances = $(".event-instances");
    const $closeIcon = $("h1 .icon");
    const $articleTitle = $(".article-title");
    const $backToWhatson = $(".back-to-whatson");
    const $mainContainer = $("#content");
    const $itemsToClose = $(
      ".article-sidebar, .article-body, .article-title-main-area .buttons "
    );

    $mainContainer.toggleClass("booking-view");

    if ($articleContent.hasClass("open")) {
      $articleContent.removeClass("open");
      $bookButton.show();
      $eventInstances.hide();
      $closeIcon.hide();
      $articleContent.show();
      $itemsToClose.show();
      $backToWhatson.removeClass("open");

      if ($(window).width() < 769) {
        $(".article-image").show();
        $articleTitle.removeClass("open");
      }

      // hide project breadcrumb
      $(".project-template-default .article-title").css(
        "margin-bottom",
        "36px"
      );
      $(".article-title + .breadcrumb").show();
    } else {
      if(e && $(e.target).parents('.inpage-links').length) {
        $('html, body').animate({
            scrollTop: $('.article-title__container').offset().top - 20 - $('.header').height()
        }, 'slow');
      }

      $articleContent.addClass("open");
      $bookButton.hide();
      $closeIcon.show();
      $eventInstances.show();
      $articleContent.hide();
      $itemsToClose.hide();
      $backToWhatson.addClass("open");


      if ($(window).width() < 769) {
        $(".article-image").hide();
        $articleTitle.addClass("open");
      }

      // hide project breadcrumb
      $(".project-template-default .article-title").css(
        "margin-bottom",
        "26px"
      );
      $(".article-title + .breadcrumb").hide();

      $('html, body').animate({
            scrollTop: $('.article-title__container').offset().top - 20 - $('.header').height()
      }, 'slow');
    }
  },

  setFilterButtonText: function(e) {
    const $checkbox = $(e.target);
    const $dropdown = $checkbox.closest(".filter-dropdown");
    const $button = $dropdown.find(".filter-dropdown__button");
    const $buttonText = $button.find(".filter-dropdown__button-text");
    const $checkedInput = $dropdown.find("input:checked");

    if($checkedInput.length === 0) {
      $buttonText.text($button.attr('data-text'))
      return
    }

    if($checkedInput.length === 1 && $buttonText.text() !== $($checkedInput[0]).attr("data-text")+'...') {
      $buttonText.text($($checkedInput[0]).attr("data-text")+'...')
      return
    }
  },

  setFilter: function(e) {
    this.setFilterButtonText(e);

    const className = "instances__item--hide"
    const $checkboxPrice = $(".filter-dropdown input[name='price']:checked");
    const $checkboxTerm = $(".filter-dropdown input[name='term']:checked");
    const $instances = $(".instances__item");
    const $instancesMessage = $(".event-instances__message");
    const $resetButton = $(".event-instances__filter-reset");

    $instances.each(function() {
      const $item = $(this);
      let matchesPrice = false;
      let matchesTerm = false;
      

      if($checkboxPrice.length) {
        const priceRange = $item.attr("data-prices");
        const prices = priceRange.split(",").map(Number);

        $checkboxPrice.each(function(){
          const priceRange = $(this).val().split("-").map(Number);

          if(prices.some(price => price > priceRange[0] && price <= priceRange[1])) {
            matchesPrice = true;
          }
        })
      } else {
        matchesPrice = true;
      }

      if($checkboxTerm.length) {
        const terms = $item.attr("data-terms").split(",");

        $checkboxTerm.each(function(){
          if(terms.includes($(this).val())) {
            matchesTerm = true;
          }
        })
      } else {
        matchesTerm = true;
      }

      if(matchesPrice && matchesTerm) {
        $item.removeClass(className);
      } else {
        $item.addClass(className);
      }            
    })

    $instancesMessage[`${$("." + className).length === $instances.length ? 'add' : 'remove'}Class`]("event-instances__message--show")
    $resetButton.prop('disabled', $checkboxPrice.length === 0 && $checkboxTerm.length === 0);
   
    if(this.swiper) this.swiper.refreshSwiper();
    
  },

  resetFilter: function(e) {
    e.preventDefault();
    const $form = $(".event-instances__filter");
    const $resetButton = $(".event-instances__filter-reset");
    
    $form.find(".filter-dropdown__button").each(function(){
      const $btn = $(this);
      const defaultText = $btn.attr('data-text');
      $btn.find(".filter-dropdown__button-text").text(defaultText);
    });

    $form[0].reset();
    $(".event-instances__message").removeClass("event-instances__message--show");
    $(".instances__item--hide").removeClass('instances__item--hide');
    $(".event-instances__message").removeClass("event-instances__message--show");

    $resetButton.prop('disabled', true);

    if(this.swiper) this.swiper.refreshSwiper();
  },

  render: function () {

    if (Backbone.history.location.hash) {
      this.toggleInstances();
    }

    this.moveMoreInfoBtn();

    const inPageLinks = new InPageLinks(".single-event");
    if (!this.swiper) {
      this.swiper = new SwiperInstances();
    } else {
      this.swiper.swiper.update();
    }

    this.getUrlParameter();
  },
});

export default Event;
